import { Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

import shiftConfigurations from 'modules/shift_management/store/api/collections/shiftConfigurations'
import type TemplateWeek from 'modules/shift_management/store/api/models/TemplateWeek'

import Banner from './Banner'
import WeekConfiguration from './WeekConfiguration'

interface Props {
  templateWeek: TemplateWeek
  shiftTemplateId: string
}

const WeekSettings = ({ templateWeek, shiftTemplateId }: Props) => {
  const templateWeekId = templateWeek.attributes.id
  const restDayFlag = hasFeature('shift_management_rest_day')

  const { loading } = useAsyncData(
    () =>
      shiftConfigurations.fetch({
        data: {
          template_weeks_ids: [templateWeekId],
        },
      }),
    []
  )

  const shiftsByWeek = shiftConfigurations.toArray()

  const title = i18n.t('shift_management.rotating_shifts.schedules.set_up')

  const description = restDayFlag
    ? i18n.t('shift_management.rotating_shifts.schedules.settings_body_breaks_rest_days')
    : i18n.t('shift_management.rotating_shifts.schedules.settings_body')

  return (
    <Section.TwoThirds
      title={title}
      description={description}
      illustration="clock-app"
      banner={<Banner />}
    >
      {loading ? (
        <Loading />
      ) : (
        <WeekConfiguration
          templateWeek={templateWeek}
          shiftsByWeek={shiftsByWeek}
          shiftTemplateId={shiftTemplateId}
        />
      )}
    </Section.TwoThirds>
  )
}

export default observer(WeekSettings)
